export const NAME = 'parameters-panels';
